import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import QuoteList from '../modules/quote/QuoteList'
import SampleList from '../modules/samples/SampleList'
import MyOrderList from '../modules/order/MyOrderList'
import AskQuoteSample from '../common/AskQuoteSample'
import OverviewTab from '../modules/overview/OverviewTab'
import DateRangeDropdown from '../common/DateRange/DateRangeDropdown'
import {
    DEFAULT_DATE_RANGE,
    getDateRangeLabel
} from '../common/DateRange/dateRangeOptions'
import { fetchCurrentBuyerRequest } from '../services/v3/Dashboard/Dashborad'
import useDocumentTitle from '../hooks/userDocumentTitle'
import { getTotalDashboardCount } from '../helpers/Util'
import { addMixpanelTrackingEvent } from '../services/CommonService'
const LIST = {
    OVERVIEW: 'OVERVIEW',
    QUOTES: 'QUOTES',
    SAMPLE: 'SAMPLE',
    ORDER: 'ORDER'
}

const MyDashboard = () => {
    const [total, setToal] = useState(null)
    const [isAskedClick, setIsAskedClick] = useState(false)
    const [dateRange, setDateRange] = useState(DEFAULT_DATE_RANGE)
    const location = useLocation()
    const navigate = useNavigate()
    const activeParam = new URLSearchParams(location.search).get('active')
    const activeStatus = new URLSearchParams(location.search).get('status')
    const [selectedList, setSelectedList] = useState(
        Object.prototype.hasOwnProperty.call(LIST, activeParam)
            ? LIST[activeParam]
            : LIST.OVERVIEW
    )
    useDocumentTitle('Nitex - Dashboard')

    const isListNotEmpty = () =>
        total && total[selectedList.toLowerCase()]?.[activeStatus]

    useEffect(() => {
        onFetchBuyerRequest()
    }, [dateRange?.type, dateRange?.fromDate, dateRange?.toDate])

    const buildDateRangeParams = () => {
        if (!dateRange) return {}
        const isCustom = dateRange.type === 'CUSTOM'
        return {
            dateRangeType: dateRange.type || 'ALL_TIME',
            startDate: isCustom ? dateRange.fromDate : undefined,
            endDate: isCustom ? dateRange.toDate : undefined
        }
    }

    const onFetchBuyerRequest = async () => {
        const data = await fetchCurrentBuyerRequest(buildDateRangeParams())
        setToal(getTotalDashboardCount(data))
    }

    const onSelectList = (value) => {
        setSelectedList(value)
        navigate(`/dashboard?active=${value}&status=ALL`)
        const requestBody = {
            requestTab: value,
            status: activeStatus
        }
        addMixpanelTrackingEvent(requestBody, 'BUYER_DASHBOARD_CHANGE_TAB')
    }

    const onDateRangeChange = (nextRange) => {
        setDateRange(nextRange)
    }

    const renderList = {
        OVERVIEW: <OverviewTab dateRange={dateRange} />,
        QUOTES: <QuoteList total={total} dateRange={dateRange} />,
        SAMPLE: <SampleList total={total} dateRange={dateRange} />,
        ORDER: <MyOrderList total={total} dateRange={dateRange} />
    }

    return (
        <>
            <div className='flex flex-wrap justify-between mt-5 lg:!mt-10 px-4'>
                <div className='quotes-sample-order-tab'>
                    <ul>
                        <li
                            className={
                                selectedList === LIST.OVERVIEW ? 'active' : ''
                            }
                            onClick={() => onSelectList(LIST.OVERVIEW)}
                        >
                            <h4 className='regular-16'>Overview</h4>
                            <p className='regular-12'>
                                {getDateRangeLabel(dateRange)}
                            </p>
                        </li>
                        <li
                            className={
                                selectedList === LIST.QUOTES ? 'active' : ''
                            }
                            onClick={() => onSelectList(LIST.QUOTES)}
                        >
                            <h4 className='regular-16'>Quotes</h4>
                            <p className='regular-12'>
                                {/* {capitalizeFirstLetter(quoteStore?.activeTab)}:{' '} */}
                                Running: {total?.quotes?.RUNNING}
                            </p>
                        </li>
                        <li
                            className={
                                selectedList === LIST.SAMPLE ? 'active' : ''
                            }
                            onClick={() => onSelectList(LIST.SAMPLE)}
                        >
                            <h4 className='regular-16'>Samples</h4>
                            <p className='regular-12'>
                                {/* {capitalizeFirstLetter(sampleStore?.activeTab)}:{' '} */}
                                Running: {total?.sample?.RUNNING}
                            </p>
                        </li>
                        <li
                            className={
                                selectedList === LIST.ORDER ? 'active' : ''
                            }
                            onClick={() => onSelectList(LIST.ORDER)}
                        >
                            <h4 className='regular-16'>Orders</h4>
                            <p className='regular-12'>
                                Running: {total?.order?.RUNNING}
                            </p>
                        </li>
                    </ul>
                </div>
                <div className='flex flex-wrap items-center gap-3 mt-5 sm:!mt-0'>
                    <DateRangeDropdown
                        value={dateRange}
                        onChange={onDateRangeChange}
                    />
                    {isListNotEmpty() ? (
                        <button
                            className='button primary'
                            onClick={() => {
                                setIsAskedClick(true)
                                addMixpanelTrackingEvent(
                                    {},
                                    'BUYER_ASK_FOR_QUOTE_SAMPLE_ON_CLICK'
                                )
                            }}
                        >
                            Ask for quote/sample
                        </button>
                    ) : null}
                </div>
            </div>
            <div className='tab-contents mt-5 px-4'>
                {renderList[selectedList]}
            </div>
            {isAskedClick && (
                <AskQuoteSample onCloseModal={() => setIsAskedClick(false)} />
            )}
        </>
    )
}

export default MyDashboard
